import { render, staticRenderFns } from "./GbsHelp.vue?vue&type=template&id=5bf31378"
import script from "./GbsHelp.vue?vue&type=script&lang=ts"
export * from "./GbsHelp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports